import LottieView from '../LottieView';

export function EllipseAnimation(props?: any) {
  return (
    <LottieView
      style={[writing_dots_style, props?.style]}
      hardwareAccelerationAndroid
      autoPlay
      loop
      resizeMode="cover"
      source={require('./dots.json')}
      {...props}
    />
  );
}

const writing_dots_style = { width: 80 };
